<template>
  <div>
    <loading v-show="load" :fullscrean="true" text="Carregando os dados"/>
    <div v-show="!load">
      <div v-if="!component">
        <bottom-bar ref="bottomBar" hide-botton="true"/>
        <div class="fixed-bottom bg-white fixed-container" :class="{'d-md-none': origin !== '8'}" v-if="qtdSacola">
          <div class="bg-white border-top">
            <div class="p-3">
              <a href="javascript:" class="btn btn-primary text-white btn-block font-weight-bold btn-bottom" @click="$emit('openSacola')" style="max-width: 500px; min-height: 53px">
                <div id="sacolaAnimated" class="d-flex justify-content-between align-items-center">
                  <div style="width: 30px">
                    <icon name="sacola" size="24" full="true"/>
                  </div>
                  <div class="font-weight-bold">
                    Ver Sacola
                  </div>
                  <div class="text-center" style="width: 30px">
                    <span class="badge badge-light rounded-circle text-primary" style="width: 19px; height: 19px">{{qtdSacola}}</span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div :class="{'content': !component, 'pb-6' : qtdSacola && !component}">
        <div class="container-fluid">
          <div class="mb-3 position-relative" @click="searching = true">
            <VueFuse :list="produtos" :fuse-opts="options" :map-results="true" id="search" placeholder="Pesquisar"
                     class="form-control w-100 ipt-pesquisar" @fuse-results="handleResult" @fuse-input="(v) => this.termo = v"/>
            <icon name="search" size="15" class="text-primary" v-show="!termo.length && !searching" style="position: absolute; top: 9px; right: 13px"/>
          </div>
          <div class="alert alert-warning d-flex justify-content-between" v-if="termo.length">
            <span>Filtro de pesquisa ativado</span>
            <a href="javascript:" @click="changeMenu()">Limpar</a>
          </div>
          <div class="row no-gutters">
            <div class="menu-container" :class="origin === '8' ? 'col-md-3 pr-md-3' : 'col-xl-3 pr-xl-3'" v-show="!termo.length">
              <div id="menuCategorias" :class="{menuFixed}">
                <categorias-menu ref="menu" @changeMenu="changeMenu" v-if="bdCategorias.length > 0"/>
              </div>
            </div>
            <div :class="termo.length ? 'col-xl-12' : (origin === '8' ? 'col-md-9' : 'col-xl-9')">
              <div v-if="termo.length">
                <produtos :produtos="search" @openProduto="openProduto"/>
              </div>
              <div v-show="!termo.length">
                <div class="mt-md-2 mb-4" v-if="categoria">
                  <div class="mb-3">
                    <h5 class="font-weight-bold mb-0">{{categoria.nome_categoria}}</h5>
                    <p class="mb-0" v-if="categoria.descricao_categoria">{{categoria.descricao_categoria}}</p>
                  </div>
                  <produtos :produtos="categoria.produtos" @openProduto="openProduto"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <produto :categoria="categoria" ref="produto" :empresaAberta="empresaAberta" @modalImage="openModalImg"/>
    <modal-image :opened="modalImage" :url="modalImage ? modalImage : base_cdn + '/static/imgs/default.png'" @closeModal="modalImage = false"/>
  </div>
</template>

<script>
  import TopBar from '../components/TopBar'
  import Loading from '../components/Loading'
  import CategoriasMenu from '../components/CategoriasMenu'
  import Produtos from '../components/ProdutosCategoria'
  import CardInfo from '../components/CardInfo'
  import Produto from '../components/Produto'
  import Icon from "../components/Icon";
  import ModalImage from "../components/ModalImage";
  import CSacola from "../components/CSacola";
  import BottomBar from "../components/BottomBar";
  import VueFuse from 'vue-fuse'

  export default {
    name: 'Categorias',
    components: {VueFuse, BottomBar, CSacola, ModalImage, Icon, TopBar, Loading, CategoriasMenu, Produtos, CardInfo, Produto},
    props: ['component'],
    data() {
      return {
        load: false,
        url: '',
        categoria: null,
        urlParams: '',
        empresaAberta: false,
        destaque: false,
        modalImage: false,
        menuFixed: false,
        searching: false,
        termo: '',
        search: [],
        produtos: [],
        options: {
          shouldSort: true,
          threshold: 0.2,
          location: 0,
          distance: 100,
          minMatchCharLength: 1,
          keys: ["nome_produto", "nome_categoria", "descricao_produto", "sabores"]
        },
      }
    },

    methods: {
      handleResult(r) {
        this.search = r;
      },

      getProdutos(cat, produto) {
        let categoria = cat ? this.bdCategorias.find(c => c.id_categoria === cat) : null;
        categoria = categoria || this.bdCategorias[0];

        if (!this.component) {
          this.changeMenu(categoria);

          if (produto) {
            this.openProduto(produto, categoria.id_categoria);
          }

        } else {
          this.categoria = categoria;
        }
      },

      openProduto(id, id_categoria) {
        if (this.component) {
          this.$router.push(`${this.url}/categorias/?id=${id_categoria}&produto=${id}`);

        } else {
          this.$refs.produto.openProduto({ id, id_categoria });
        }
      },

      changeMenu(cat, change) {
        this.categoria = cat || this.bdCategorias[0];
        this.termo = '';

        if (!this.component) {
          const id_categoria = this.categoria?.id_categoria || '';
          window.history.replaceState(null, null, `${window.location.pathname}?id=${id_categoria}`);
        }

        if (document.getElementById('search')) {
          document.getElementById('search').value = '';
        }

        let top = 0;

        if (this.component) {
          const div = document.getElementById('divProdutos');
          top = div ? (div.offsetTop - (window.innerWidth > 768 ? 80 : 14)) : 0;
        }

        window.scrollTo({ top, left: 0, behavior: "smooth" });
        this.$refs.menu.changeMenuBar(this.categoria.id_categoria, !change);
      },

      openModalImg(img) {
        if (img) {
          this.modalImage = img;
        }
      },

      scroll() {
        this.menuFixed = (window.scrollY > 133);
      }
    },

    mounted() {
      this.empresaAberta = this.modo_catalogo || this.empresa.empresaAberta;

      this.$nextTick(() => {
        this.urlParams = new URLSearchParams(window.location.search);
        this.destaque = this.urlParams.get('destaque');

        if (this.urlParams.get('search')) {
          this.$helpers.focusrElement('search');
        }

        this.getProdutos(this.urlParams.get('id'), this.urlParams.get('produto'));
      });

      if (this.bdCategorias.length) {
        this.bdCategorias.forEach(c => {
          this.produtos = this.produtos.concat(c.produtos.map(p => {
            return { ...p,
              'sabores': p.sabores ? p.sabores.split(",") : [],
              'nome_categoria': c.nome_categoria
            }
          }))
        });
      }

      this.url = this.origin === '5' ? '/' + this.$store.state.empresa.dominio_delivery : '';
    },

    created() {
      document.body.classList.remove("modal-open");
      document.addEventListener("scroll", this.scroll);
    },

    beforeDestroy() {
      document.removeEventListener('scroll', this.scroll);
    },

    beforeRouteLeave(to, from, next) {
      if (['Cadastro','Login','Finalizar'].includes(to.name)) {
        next();
        return;
      }

      if (this.$refs.bottomBar && this.$refs.bottomBar.openSacola) {
        this.$refs.bottomBar.openSacola = false;
        next(false);

      } else if (this.modalImage) {
        this.modalImage = false;
        next(false);

      } else if (this.$refs.produto && this.$refs.produto.aberto && !this.destaque) {
        this.$refs.produto.closeProduto();
        next(false);

      } else {
        next()
      }
    },

    computed: {
      empresa() {
        return this.$store.state.empresa
      },

      bdCategorias() {
        return this.$store.state.cardapio.categorias
      },

      qtdSacola() {
        const qtd = this.$store.state.sacola.produtos.length;
        return qtd < 10 ? qtd : 9;
      },

      zap() {
        return this.$store.state.zap
      }
    }
  }
</script>
<style>
  .pb-6 {
    padding-bottom: 92px!important;
  }

  .form-control.ipt-pesquisar {
    padding-top: 21px;
    padding-bottom: 21px;
  }

  #menuCategorias {
    background-color: #F4F5F7;
    transition: box-shadow 0.3s;
  }

  @media (max-width: 768px) {
    .menu-container {
      min-height: 100px;
    }

    #menuCategorias {
      margin-bottom: 0;
    }

    .pb-6 #menuCategorias.menuFixed {
      top: 0;
      left: 0;
      right: 0;
      z-index: 1;
      display: block;
      position: fixed;
      background-color: #F4F5F7;
      padding: 10px 15px 6px;
      box-shadow: var(--shadow);
      margin-bottom: 0;
    }
  }

  @media (min-width: 769px) {
    #menuCategorias {
      top: 82px;
      position: sticky;
    }
  }
</style>
